export const RightArrowIcon = ({ fill, width, height, style, onClick }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            height={height ? height : '24px'}
            viewBox='0 0 24 24'
            width={width ? width : '24px'}
            fill={fill ?? '#000000'}
            style={style}
            onClick={onClick}
        >
            <path d='M0 0h24v24H0V0z' fill='none' />
            <path d='M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z' />
        </svg>
    );
};
